import { getContrast } from 'polished'

export function getWCAGTextColor(textColor1: string, textColor2: string, background: string) {
	const whiteTextColorContrast = getContrast(textColor1, background)
	const blackTextColorContrast = getContrast(textColor2, background)

	return whiteTextColorContrast > blackTextColorContrast ? textColor1 : textColor2
}
